export default __webpack_public_path__ + "img/8dd17d28f7f292b2eba7642de693b9fb.png";